import React from 'react';
import {Box, CircularProgress, Collapse, IconButton, List, ListItem, Paper, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';
import HistoryIcon from '@mui/icons-material/History';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Styled list item
const StandardListItem = styled(ListItem)(({theme}) => ({
    backgroundColor: '#181826',
    borderBottom: '1px solid #303030',
    '&:hover': {
        backgroundColor: '#1a1a1a',
    },
    color: '#e0e0e0',
    padding: '15px',
    textAlign: 'right',
}));

// Styled typography for the header and text
const SubtleTypography = styled(Typography)(({theme}) => ({
    background: 'linear-gradient(180deg, #693e86bd, #34929a)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 'bold',
    fontSize: '1.2rem',
}));

const History = ({isModalOpen, handleCloseModal, isLoading, historyItems}) => {
    const [isExpanded, setIsExpanded] = React.useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <>
            <Paper sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                mx: 'auto',
                maxWidth: '500px',
                borderTopLeftRadius: '18px',
                borderTopRightRadius: '18px',
                boxShadow: '0px -5px 7px 0px rgb(48 35 73 / 30%)',
                bgcolor: '#10101b',
                color: 'white',
                transition: 'max-height 0.3s ease',
                maxHeight: isExpanded ? '60%' : '80px',
            }}>
                {/* Header with collapse/expand button */}
                <Box sx={{
                    p: 2,
                    position: 'relative',
                    textAlign: 'center',
                    bgcolor: '#181826',
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '10px'
                }}>
                    <SubtleTypography variant="h6">היסטוריית פגישות</SubtleTypography>
                    <HistoryIcon sx={{marginRight: 1, color: 'white'}}/>
                    <IconButton
                        onClick={toggleExpand}
                        sx={{position: 'absolute', right: 16, color: 'white'}}
                    >
                        {isExpanded ? <ExpandMoreIcon/> : <ExpandLessIcon/>}
                    </IconButton>
                </Box>

                <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                    <Box sx={{
                        maxHeight: 'calc(60vh - 60px)',
                        overflowY: 'auto',
                    }}>
                        {isLoading ? (
                            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                                <CircularProgress color="inherit"/>
                            </Box>
                        ) : historyItems.length === 0 ? (
                            <Box sx={{textAlign: 'center', color: '#e0e0e0', py: 2}}>
                                <Typography variant="body1">אין היסטוריית שיחות עדיין</Typography>
                            </Box>
                        ) : (
                            <List sx={{padding: 0}}>
                                {historyItems.map((item, index) => (
                                    <StandardListItem key={index}>
                                        <Box sx={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                                            <Typography sx={{color: '#34929a'}}>
                                                {item.summary}
                                            </Typography>
                                            <Typography variant="body2" sx={{color: '#9e9e9e', marginLeft: 2}}>
                                                {new Date(item.startTime).toLocaleDateString()}
                                            </Typography>
                                        </Box>
                                    </StandardListItem>
                                ))}
                            </List>
                        )}
                    </Box>
                </Collapse>
            </Paper>
        </>
    );
};

export default History;
